import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import telegramIcon from "@/assets/telegram.svg";
import instagramIcon from "@/assets/instagram.svg";
import whatsappIcon from "@/assets/whatsapp.svg";
import { useTranslation } from "@/hooks/useTranslation";

export default function ContactInfoFields({
  form,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
}) {
  const t = useTranslation();

  return (
    <>
      <div className="flex gap-2">
        <h4 className="text-lg font-semibold leading-none tracking-tight text-gray-200">
          {t.USER_FORM.LABELS.CONTACT_INFO_TITLE}
        </h4>
      </div>

      <div className="text-sm text-gray-500">
        {t.USER_FORM.LABELS.CONTACT_INFO_DESCRIPTION}
      </div>

      <FormField
        control={form.control}
        name="telegram"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel className="flex items-center">
              <img
                src={telegramIcon}
                alt="Telegram Icon"
                className="w-5 h-5 mr-2"
              />
              Telegram
            </FormLabel>
            <div className="flex items-center">
              @
              <div className="ml-2 w-full">
                <FormControl>
                  {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment  */}
                  <Input
                    {...field}
                    value={field.value || ""}
                    className="text-base"
                    autoCapitalize="none"
                  />
                </FormControl>
                <FormMessage className="mt-1" />
              </div>
            </div>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="instagram"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel className="flex items-center">
              <img
                src={instagramIcon}
                alt="Instagram Icon"
                className="w-5 h-5 mr-2"
              />
              Instagram
            </FormLabel>
            <div className="flex items-center">
              @
              <div className="ml-2 w-full">
                <FormControl>
                  {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment  */}
                  <Input
                    {...field}
                    value={field.value || ""}
                    className="text-base"
                    autoCapitalize="none"
                  />
                </FormControl>
                <FormMessage className="mt-1" />
              </div>
            </div>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="whatsapp"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel className="flex items-center">
              <img
                src={whatsappIcon}
                alt="Whatsapp Icon"
                className="w-5 h-5 mr-2"
              />
              WhatsApp
            </FormLabel>
            <div>
              <FormControl>
                {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment  */}
                <Input
                  {...field}
                  value={field.value || "+"}
                  className="text-base"
                  inputMode="numeric"
                />
              </FormControl>
              <FormMessage className="mt-1" />
            </div>
          </FormItem>
        )}
      />
    </>
  );
}
